// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-page-header[data-v-7f8448e9]{font-size:28px;font-weight:bold}.group-page-chats__header[data-v-7f8448e9]{font-size:24px}\n", ""]);
// Exports
module.exports = exports;
